module.exports = function years() {
    return [
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026',
    ];
}
